export default {
    SET_BLOCK_ON_REPLIEsS(state, block) {        
        state.replies = state.replies.map(reply => reply.id !== block);
    },
};